module.exports = __webpack_public_path__ + "assets/icon-star-component.d8eff163.svg";